import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/system";

export const MiImagePreview = ({
  url,
  handleDelete,
}: {
  url?: string;
  handleDelete?: () => void;
}) => {
  const { classes } = useStyles();

  if (!url) {
    return null;
  }

  return (
    <Box
      className={`${classes.previewImgContainer} ${
        handleDelete && classes.previewImgContainerHover
      }`}
      onClick={handleDelete}
    >
      <img alt="preview" src={url} className={classes.previewImg} />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  previewImgContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    borderRadius: 8,
    overflow: "hidden",
  },
  previewImgContainerHover: {
    cursor: "pointer",
    "&:hover::after": {
      content: '"×"',
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(0,0,0,0.55)",
      color: theme.palette.common.white,
      fontSize: 24,
      fontWeight: 600,
      lineHeight: 1,
    },
  },
  previewImg: {
    width: "100%",
    height: "100%",
    borderRadius: 8,
    overflow: "hidden",
    objectFit: "contain",
  },
}));
